const { permissions } = require('../../constants/permissions');

require('./backupsDetailsView.style.scss');
// const Job = require('../../model/Job');
class BackupsDetailsViewController {
    constructor($scope, $timeout, $state, sseService, crudService, storageService, utilsService, iamPersistenceService) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$state = $state;
        this.sseService = sseService;
        this.crudService = crudService;
        this.storageService = storageService;
        this.utilsService = utilsService;
        this.iamPersistenceService = iamPersistenceService;
    }

    setSubGrid(grid, refresh) {
        this.detailsGrid = grid;
        this.ctxDetailsGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: []
        };
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('51%');
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('15%');
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('17%');
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('17%');

        this.$timeout(() => {
            let user = this.storageService.getUser();
            this.detailsGrid.tableName = (refresh ? grid.tableId : this.detailsGrid.tableName) + '-' + user.username + '-' + user.userGroupName;
            if (angular.isDefined(this.storageService.getGridWolumnsWidthMapInPct(this.detailsGrid.tableName))) {
                this.ctxDetailsGridStyleConfig.columnsWidthMapInPct = this.storageService.getGridWolumnsWidthMapInPct(this.detailsGrid.tableName);
            }
            this.detailsGridColumnsStyleConfig = this.ctxDetailsGridStyleConfig;
            this.detailsGridFlag = true;
        }, 0);
    }

    goToRelatedJob(item, parentData) {
        if (!item) return;
        let data = parentData ? parentData : {
            backupManagedUuid: parent && parent.backup ? parent.backup : (item.backupManagedTaskUuid ? item.backupManagedTaskUuid : null),
            archiveWeeklyManagedUuid: parent && parent.arhiveWeek && parent.arhiveWeek.length ? this.setSearchUuid(parent.arhiveWeek) : (item.archiveWeeklyManagedTaskUuid ? this.setSearchUuid(item.archiveWeeklyManagedTaskUuid) : null),
            archiveMonthlyManagedUuid: parent && parent.arhiveMonth && parent.arhiveMonth.length ? this.setSearchUuid(parent.arhiveMonth) : (item.archiveMonthlyManagedTaskUuid ? this.setSearchUuid(item.archiveMonthlyManagedTaskUuid) : null),
            archiveYearlyManagedUuid: parent && parent.arhiveYear && parent.arhiveYear.length ? this.setSearchUuid(parent.arhiveYear) : (item.archiveYearlyManagedTaskUuid ? this.setSearchUuid(item.archiveYearlyManagedTaskUuid) : null),
            copyManagedUuid: parent && parent.copy && parent.copy.length ? this.setSearchUuid(parent.copy) : (item.copyManagedTaskUuid ? this.setSearchUuid(item.copyManagedTaskUuid) : null),
            jobUuid: item && typeof (item) === 'string' ? item : null
        };
        this.$timeout(() => {
            this.$state.go('app.jobs', data);
        }, 200);
    }

    setSearchUuid(item) {
        return item.toString().split().join('||');
    }

    hasBackupsViewPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.VM_BACKUPS);
    }
}

const backupsDetailsViewComponent = {
    controller: BackupsDetailsViewController,
    template: require('./backupsDetailsView.template.html'),
    bindings: {
        tableName: '@',
        eventIdName: '@',
        ownerFlag: "<",
        canAdminWatch: "<",
        selectedItems: '<',
        restorePoints: '<',
        selectedRestorePoint: '=',
        ctxGridMinOverflow: '<',
        ctxGridMaxOverflow: '<',
        oneLetterTags: '<',
        parentJobHandling: '<?',
        showBackupsAction: '&'
    }
};

BackupsDetailsViewController.$inject = ['$scope', '$timeout', '$state', 'sseService', 'crudService', 'storageService', 'utilsService', 'iamPersistenceService'];

module.exports = backupsDetailsViewComponent;




// WEBPACK FOOTER //
// ./src/azurebackup/components/backupsDetailsView/backupsDetailsView.component.js